<script>
	import { ChevronDownIcon, ChevronUpIcon } from "svelte-feather-icons";
	import { auth, hasRole } from "../auth";
	// import { useNavigate } from 'svelte-navigator'
	import { doFetch, api } from '../api'
	import { getContext, onDestroy, onMount } from "svelte";
	import { derived } from 'svelte/store'
	import LinkInfo from "./LinkInfo.svelte";
	import notyf from '../utils/notyf'
	import AsyncButton from "../components/AsyncButton.svelte";
	import LinkStates from "./linkStates";
	import GcsStatus from "./gcsStatus";
	import { failCodeMessage, devModeEnabled } from "../const";

	// const navigate = useNavigate()
	const flightContext = getContext("flight")
	let flight
	let replayInfo
	let info 
	let liveInfo
	let liveWs
	let linkStates
	let gcsStatus

	let isCollapsed = false
	let showAdvanced = false
	let showFlightControls = false

	const flightStore = api.flights.store
	

	onMount(() => {
		flight = flightContext.get()
		replayInfo = flight.replayInfoStore
		info = derived(flight.serverStateStore, (realInfoStore, set) => {
			const timer = setTimeout(() => {
				set(realInfoStore)
			}, 100)
			
			return () => clearTimeout(timer) 
		})
		liveInfo = flight.liveServerStateStore
		liveWs = flight.liveWs
		
		linkStates = flight.getHandler(LinkStates)
		gcsStatus = flight.getHandler(GcsStatus)
	})
	onDestroy(() => {
		flight.releaseHandler(LinkStates)
		flight.releaseHandler(GcsStatus)
	})

	function toggleCollapsed() {
		isCollapsed = !isCollapsed;
	}

	function toggleShowAdvanced() {
		showAdvanced = !showAdvanced
	}

	async function toggleHideFlight() {
		const flightInfo = $flightStore[$liveInfo.id]
		await api.flights.update($liveInfo.id, {isHidden:!flightInfo.isHidden})
	}

	let reconnectSeconds;
	let reconnectInterval;
	function updateReconnect(time) {
		reconnectSeconds = time / 1000;
		if (reconnectInterval) {
			clearInterval(reconnectInterval);
			reconnectInterval = null;
		}
		reconnectInterval = setInterval(() => {
			reconnectSeconds--;
		}, 1000);
	}

	$: {
		if ($liveInfo && $liveInfo.state !== "ENDED" && !$liveWs.connected) {
			updateReconnect($liveWs.reconnectTime);
		} else {
			reconnectSeconds = 0;
			clearInterval(reconnectInterval);
		}
	}
	async function startFlight() {
		try {
			await doFetch(`flights/${$liveInfo.id}/start`, 'POST')
		} catch (error) {
			notyf.error(error.message)
		}
	}
	async function endFlight() {
		try {
			await doFetch(`flights/${$liveInfo.id}/complete`, 'POST')
		} catch (error) {
			notyf.error(error.message)
		}
	}
</script>

{#if $info && $info.state}
	{#if reconnectSeconds}
		<div class="wsError">
			Live Connection Error
			<p class="reconnect">
				{#if reconnectSeconds > 0 && $liveWs.reconnectTime > 2000}
					Retrying in {reconnectSeconds}s ...
				{:else}
					Retrying now ...
				{/if}
			</p>
		</div>
	{/if}
	<div class="sidebar flightSelectedMobile" class:replaying={!$replayInfo.isFollowingHead}>
		<div id="flightInfo" class={"sidebar-tile " + $liveInfo.state}>
			<div class="flightCard">
				<header>
					<div class="flightToggle" on:click={toggleCollapsed}>
						{#if isCollapsed}
							<ChevronDownIcon />
						{:else}
							<ChevronUpIcon />
						{/if}
					</div>
					<div class="headerContainer">
						<div class="flightInfo">
							<h3 class="flightName">{$liveInfo.name}</h3>
							<div>ID <span />{$liveInfo.id}</div>
						</div>
						<div class="badgeContainer">
							<div class={"badge status " + $liveInfo.state.toLowerCase()}>
								{$liveInfo.state}
							</div>
							{#await flight.historyPromise}
								<div class="badge loadingBadge">Loading</div>								
							{:then _} 
								<!-- empty -->
							{/await}
						</div>
					</div>
				</header>
				{#if !isCollapsed}
					<div class="flightDetails">
						{#if $liveInfo.createdAt}
							<div>Created:</div>
							<div>{new Date($liveInfo.createdAt).toLocaleString()}</div>
						{/if}
						{#if $liveInfo.startedTime}
							<div>Started:</div>
							<div>{new Date($liveInfo.startedTime).toLocaleString()}</div>
						{/if}
						{#if $liveInfo.endedTime}
							<div>Ended:</div>
							<div>{new Date($liveInfo.endedTime).toLocaleString()}</div>
						{/if}
						{#if $devModeEnabled} 
							<div>Datamux:</div>
							<div>{$liveInfo.datamuxId}</div>
						{/if}
					</div>

					{#if $liveInfo.failCode}
						<div class="failError">{failCodeMessage[$liveInfo.failCode]}</div>
					{/if}
					{#if !flight.isGuest && $liveInfo && $liveInfo.state !== "ENDED"}
						<div class="buttons">
							<div class='advancedToggle' on:click={() => showFlightControls = !showFlightControls}>
								<div>Flight Controls</div>
								{#if showFlightControls}
									<ChevronUpIcon size="16" />
								{:else}
									<ChevronDownIcon size="16" />
								{/if}
							</div>
							{#if showFlightControls}
								{#if hasRole($auth, 'fo') && $liveInfo}
									{#if $liveInfo.state == "READY"}
										<AsyncButton handler={startFlight}>Start Flight</AsyncButton>
									{/if}
									{#if $liveInfo.state !== "ENDED"}
										<AsyncButton color="red" handler={endFlight}>{$liveInfo.state === "READY" ? "Cancel" : "End"} Flight</AsyncButton>
									{/if}
								{:else if $liveInfo.state === "READY"}
									<div class='startHelper'>A Flight Operator must start the flight.</div>
								{/if}
							{/if}
						</div>
					{/if}
				{/if}
			</div>
		</div>
		{#if !flight.isGuest && hasRole($auth, 'fo') && $liveInfo && $liveInfo.state === "ACTIVE"}
			<div
				class="sidebar-tile flightDetailsHeading">
				<div class="title">GCS Connection Info</div>
			</div>
			<div class="sidebar-tile gcsDetails" data-class-field="state">
				<div>TCP Host:</div>
				<div>{$liveInfo.dataTcpHost}</div>
				<div>TCP Port:</div>
				<div>{$liveInfo.dataTcpPort}</div>
				<div>WS Url:</div>
				<div class="gcsWsUrl">
					{#if $liveInfo.dataWsHost && $liveInfo.dataWsPort}
						ws://<span>{$liveInfo.dataWsHost}</span>:<span>{$liveInfo.dataWsPort}</span>
					{/if}
				</div>
			</div>
		{/if}
		{#if !isCollapsed}
			<div class="sidebar-tile linkList">
				<header>
					<h3>C2 Links</h3>
					{#if !flight.isGuest}
						<div class='extras'>
							{#if !$replayInfo.isFollowingHead}
								<div class="replayingPill badge">Replaying</div>
							{/if}
							{#if $info.state !== "CREATED"}
								{#if $gcsStatus}
									<div class="gcsConnection connected">GCS connected</div>
								{:else}
									<div class="gcsConnection disconnected">GCS disconnected</div>
								{/if}
							{/if}
						</div>
					{/if}
				</header>
				
				<div class="assigned-radios v-radio-box">
					{#if $linkStates}
						{#each Object.values($linkStates) as link (link.id)}
							<LinkInfo {link} />
						{/each}
					{/if}
				</div>
			</div>
			{#if $liveInfo.state === 'ENDED' && hasRole($auth, 'con')}
				<div class="advanced">
					<div class='advancedContent'>
						<div class='advancedToggle' on:click={toggleShowAdvanced}>
							<div>Advanced Options</div>
							{#if showAdvanced}
								<ChevronUpIcon size="16" />
							{:else}
								<ChevronDownIcon size="16" />
							{/if}
						</div>
						{#if showAdvanced}
							<div class='advancedOption'>
								<!-- <input id='toggleHidden' type='checkbox' checked={$flightStore[$liveInfo.id].isHidden} on:change={toggleHideFlight}>
								<label for='toggleHidden'>Hide from Flight List</label> -->
								<AsyncButton handler={toggleHideFlight}>{$flightStore[$liveInfo.id].isHidden ? "Show in Flight List" : "Hide from Flight List"}</AsyncButton>
							</div>
						{/if}
					</div>
				</div>
			{/if}
		{/if}
	</div>
{/if}

<style>
	#flightInfo {
		background-color: rgb(37,37,37);
	}

	.linkList header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.wsError {
		position: absolute;
		left: 50%;
		top: 50px;
		background-color: tomato;
		border: 1px solid black;
		border-radius: 5px;
		padding: 0.5em;
		font-size: 11pt;
		color: white;
		font-weight: bold;
	}
	.reconnect {
		font-size: 8pt;
		font-weight: unset;
		text-align: center;
		margin: 2px;
		font-style: italic;
	}

	.badgeContainer {
		text-align: center;
	}

	.badge {
		border-radius: 0.4rem;
		padding: 0.4rem;
		font-size: 8pt;
	}
	.sidebar.replaying {
		background-color: rgb(88 70 37);
	}

	.loadingBadge {
		background-color: rgb(153, 0, 255);
	}
	.headerContainer {
		flex: 1;
		display: grid;
		grid-template-columns: minmax(100px, 1fr) auto;
	}

	.headerContainer .flightName {
		white-space: normal;
		margin-right: 8px;
	}
	.flightInfo {
		flex-grow: 0;
	}
	.flightDetails {
		margin-top: 8px;
	}

	.flightToggle {
		text-align: center;
		color: white;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 8px;
		margin-top: 8px;
		max-height: 18px;
		max-width: 18px;
		background-color: grey;
		border-radius: 4px;
		cursor: pointer;
	}

	.startHelper {
		font-style:italic;
		color:lightgray;
		text-align:center;
	}

	.sidebar {
		background-color:rgb(37, 37, 37);
		overflow-y: auto;
	}

	.replayingPill {
		background-color: rgb(155, 108, 21);
		color: white;
		grid-area: pill;
	}

	.buttons {
		display: grid;
		gap: 8px;
		background-color: grey;
		padding: 8px;
		border-radius: 8px;
	}

	.advanced {
		color:lightgray;
		padding: 2px;
		background-color:rgba(37, 37, 37, 1);
	}
	
	.advancedContent {
		/* border-radius:8px; */
		padding: 4px 16px;
	}
	
	.advancedToggle {
		display:flex;
		align-items: center;
		justify-content:space-between;
		user-select: none;
		cursor: pointer;
	}

	.advancedOption {
		margin: 4px 0;
	}

	.advancedOption input {
		margin:0;
		margin-right:4px;
		padding:0;
	}

	.flightDetailsHeading {
		margin-top: 8px;
		color:white;
		margin-bottom: 0;
		padding-bottom: 4px;
	}

	.flightDetailsHeading .title {
		font-size: 12pt;
		font-weight: bold;
	}

	.flightDetails {
		display: grid;
		grid-template-columns: 40% 60%;
		justify-items: stretch;
		grid-row-gap: 0.8rem;
		align-items: center;
		margin-bottom: 8px;
		color:white;
	}

	.gcsDetails {
		color:white;
		display: grid;
		grid-template-columns: 40% 60%;
		justify-items: stretch;
		grid-row-gap: 0.8rem;
		align-items: center;
		color:white;
	}

	.gcsConnection {
		font-size: 10px;
		margin-top: 2px;
		color: rgb(255, 75, 75);
		grid-area: gcs;
	}
	.gcsConnection.connected {
		color: rgb(91, 177, 70);
	}

	.extras {
		display: grid;
		grid-template-rows: auto auto;
		grid-template-columns: 1fr auto 1fr;
		grid-template-areas: ". pill ." "gcs gcs gcs";
	}

	.failError {
		color: red;
		margin-top: 8px;
		background-color: #440000;
		text-align: center;
		padding:4px;
	}

	@media only screen and (max-width: 600px) {
		.wsError {
			top: 74%;
			left: 2%;
			width: 96%;
			text-align: center;
		}

	}

</style>
